import { createFileRoute } from "@tanstack/react-router";
import { Send } from "lucide-react";
import { AdminEmptyTab } from "@/components/dashboard/AdminEmptyTab";

export const Route = createFileRoute("/dashboard/admin/whatsapp")({
  head: () => ({ meta: [{ title: "WhatsApp · Admin" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <AdminEmptyTab
      title="WhatsApp"
      description="WhatsApp outreach activity and conversations."
      stats={[
        { label: "Sent (24h)" },
        { label: "Delivered" },
        { label: "Read" },
        { label: "Replies" },
      ]}
      body="WhatsApp message history will appear here."
      primaryAction={{ label: "Send message", icon: Send }}
      columns={["Direction", "Number", "Message", "Status", "Sent"]}
    />
  ),
});
